import React, { memo } from 'react';
import { LabelStyled } from '@yme/atoms/input/styled';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { DatePicker } from '../date-picker';
export const FormFieldDate = memo(({ id, label, isRequired, className, ...pickerProps }) => (React.createElement("div", { className: className },
    label && (React.createElement(RegularTextLevel4, { weight: 500 }, label && (React.createElement(LabelStyled, { isRightToLeft: false, isRequired: isRequired, htmlFor: id }, label)))),
    React.createElement(DatePicker, { ...pickerProps }))));
FormFieldDate.displayName = 'FormFieldDate';
